<div *ngIf="IsOpen" style="position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.5);z-index:2000;display:flex;align-items:center;justify-content:center;">
  <div style="width:92vw;height:90vh;background:#fff;border-radius:16px;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,0.2);overflow:hidden;">

    <!-- Header -->
    <div style="display:flex;justify-content:space-between;align-items:center;padding:16px 24px;border-bottom:1px solid #e8e8e8;background:#fafbfc;flex-shrink:0;">
      <div style="display:flex;align-items:center;gap:14px;">
        <button type="button" (click)="Cancel()"
          style="width:36px;height:36px;border-radius:8px;border:1px solid #ddd;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:14px;color:#555;">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <div>
          <h2 style="margin:0;font-size:18px;font-weight:700;color:#333;">{{ Template?.Name }}</h2>
          <span *ngIf="Template?.Description" style="font-size:12px;color:#999;">{{ Template?.Description }}</span>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div style="flex:1;overflow-y:auto;padding:24px;background:#f5f7fa;">
      <div style="background:#fff;padding:24px;border-radius:12px;box-shadow:0 1px 4px rgba(0,0,0,0.06);">
        <app-form-fill-cdms *ngIf="Template"
          [fields]="Template.Fields"
          [mode]="'fill'"
          [values]="PreloadValues"
          (valuesChange)="OnValuesChange($event)"
          (filesChange)="OnFilesChange($event)">
        </app-form-fill-cdms>
      </div>
    </div>

    <!-- Footer -->
    <div style="display:flex;justify-content:space-between;align-items:center;padding:14px 24px;border-top:1px solid #e8e8e8;background:#fafbfc;flex-shrink:0;">
      <button type="button" (click)="Cancel()"
        style="padding:9px 20px;border-radius:8px;border:1px solid #ddd;background:#fff;color:#555;font-size:13px;cursor:pointer;">
        Cancelar
      </button>
      <span style="font-size:12px;color:#999;">{{ GetFilledCount() }} de {{ GetTotalCount() }} campos</span>
      <button type="button" (click)="Confirm()"
        style="display:flex;align-items:center;gap:6px;padding:9px 20px;border-radius:8px;border:none;background:#20a8e1;color:#fff;font-size:13px;font-weight:500;cursor:pointer;">
        <i class="fa-solid fa-check"></i> Confirmar y continuar
      </button>
    </div>

  </div>
</div>
